import { OnInit } from '@angular/core';
var ProductDetailComponent = /** @class */ (function () {
    function ProductDetailComponent() {
        this.refresh = false;
    }
    Object.defineProperty(ProductDetailComponent.prototype, "setComponentId", {
        set: function (id) {
            this.componentId = id;
            this.refresh = true;
        },
        enumerable: true,
        configurable: true
    });
    ProductDetailComponent.prototype.ngOnInit = function () {
    };
    ProductDetailComponent.prototype.bread = function () {
    };
    return ProductDetailComponent;
}());
export { ProductDetailComponent };
